import { envInfo } from './index'
import { getUserStatus } from '../api'

export const getWechatUnionIdFromLocal = (that) => {
  let { unionId } = that.$route.query
  let value = ''
  if (unionId && unionId !== 'null') {
    value =  unionId
    localStorage.setItem('unionId', value)
  } else {
    let unionId = localStorage.getItem('unionId')
    if (unionId) {
      value = unionId
    }
  }
  return value
}
/**
 * 获取用户账号等信息
 * @return {}
 */
export const getUserInfoFromLocal = () => {
  var result = {}
  const emailOrPhone = getCookie('emailOrPhone')
  const password = getCookie('password')
  const wechatUnionId = getCookie('wechatUnionId')
  const serviceID = getCookie('serviceID')
  const openId = getCookie('openId')
  const userId = getCookie('userId')
  const pushId = getCookie('pushId')
  const status = getCookie('status')
  const vipStatus = getCookie('vipStatus')
  const hcgReadFlag = getCookie('hcgReadFlag')
  if (emailOrPhone !== null) {
    result.emailOrPhone = emailOrPhone
    result.formatPhone = formatPhone(emailOrPhone)
  }
  if (password !== null) {
    result.password = password
  }
  if (wechatUnionId !== null) {
    result.wechatUnionId = wechatUnionId
  }
  if (serviceID !== null) {
    result.serviceID = serviceID
  }
  if (openId) {
    result.openId = openId
  }
  const authToken = getCookie('authToken')
  if (authToken) {
    result.authToken = authToken
  }
  if (userId) {
    result.userId = userId
  }
  if (pushId && pushId.length > 0) {
    result.pushId = pushId
  }
  if (status != null) {
    result.status = parseInt(status)
  }
  if (vipStatus != null) {
    result.vipStatus = parseInt(vipStatus)
  }
  if (hcgReadFlag != null) {
    result.hcgReadFlag = parseInt(hcgReadFlag)
  }
  result.chenggguo = getChenggguoQr(result.pushId)
  const info = envInfo
  try {
    if (info === 'WeChat') {
      return result
    } else if (info === 'iOS') {
      result.OSType = 'iOS'
    } else if (info === 'Android') {
      let userInfo = JSON.parse(window.AnalyticsClickListener.getAccountForH5())
      if (userInfo.emailOrPhone !== null) {
        userInfo.formatPhone = formatPhone(userInfo.emailOrPhone)
      }
      userInfo.chenggguo = getChenggguoQr(userInfo.pushId)
      return userInfo
    } else if(info === 'ali'){
      return result
    } 
    else if (info === 'Simulator') {
      // 在 PC 或 Mac 端调试时，使用固定账号。避免由于 “不在 App 环境” 造成的无法加载账号数据问题
      if (process.env.VUE_APP_MODE === 'production') {
        result = {
          emailOrPhone: '17611113591',
          formatPhone: formatPhone('17611113591'),
          authToken: '5b386be6-8214-428b-87c8-0945abb597ca2621',
          OSType: 'iOS',
          userId: '183702',
          pushId: 'EAD18582B422471005CFEB5820FC7DF4',
          status: 0,
          vipStatus: 0,
          hcgReadFlag: 0
        }
      } else {
        result = {
          emailOrPhone: '15003850015',
          formatPhone: formatPhone('15003850015'),
          authToken: '4b19d6a9-3e7d-4c64-ada4-681ed613e2e75608',
          OSType: 'iOS',
          userId: '784728',
          pushId: 'EAD18582B422471005CFEB5820FC7DF4',
          status: 0,
          vipStatus: 0,
          hcgReadFlag: 0
        }
      }

      result.chenggguo = getChenggguoQr(result.pushId)
      return result
    }
  } catch (error) {
    //个别机型微信环境判断异常
    console.log(error)
  }
  return result
}

export function getChenggguoQr(pushId) {
  //根据pushId奇偶数轮换九月孕成小助手
  let chenggguo1 = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/df606536-8c61-44f8-a044-5fe3c6529761_chengguo_contact_qr.jpg'
  // let chenggguo2 = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/b7b5ab1a-d54f-4aa2-a51a-0cbb13748025_chengguo_contact_qr2.png'
  let chenggguo = chenggguo1
  if (!pushId) {
    return chenggguo
  }
  // let lastChar = pushId[pushId.length - 1] || '0'
  // // MD5 字符串取值范围：0-9 A-F
  // if (
  //   (lastChar >= '0' && lastChar <= '4') ||
  //   (lastChar >= 'A' && lastChar <= 'C')
  // ) {
  //   chenggguo = chenggguo1
  // } else {
  //   chenggguo = chenggguo2
  // }
  return chenggguo
}

export function formatPhone(tel) {
  var reg = /^(\d{3})\d{4}(\d{4})$/
  return tel.replace(reg, "$1****$2")
}

/**
 * 获取 Cookie
 * @param key Cookie 对应的 Key
 * @return Cookie 对应的 Value
 */
export function getCookie(key) {
  // eslint-disable-next-line
  var arr, reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
  // eslint-disable-next-line
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}


export async function getUserVipTypeUtil(token){
  let res = await getUserStatus(token)
  let type = getUserVipTypeUtilData(res)
  let date = getUserVipDate(res)
  return {'type': type , 'date': date, 'userGroupId': res.userGroupId || 0}
}

export function getUserVipTypeUtilData(res){
  if(res.newVips.length === 0){
    // 非vip
    return 0
  }
  for (let i = 0; i < res.newVips.length; i++) {
    if(res.newVips[i].vipType === 1 && res.newVips[i].endTime === 0 ) {
      //永久vip
      return 3
    }
    if (new Date().getTime()/1000 < res.newVips[i].endTime) {
      if(res.newVips[i].vipType ===0){
        // 试用VIP
        return 4
      }
      // vip
      return 1
    }
  }
  //过期的vip
  return 2
}

export function getUserVipDate(res){
  if(res.newVips.length === 0){
    // 非vip
    return -1
  }
  for (let i = 0; i < res.newVips.length; i++) {
    if(res.newVips[i].vipType === 1 && res.newVips[i].endTime === 0 ) {
      //永久vip
      return 0
    }
    return res.newVips[i].endTime
  }
  //过期的vip
  return -1
}